import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Upload, LogOut, LogIn, Wallet, Bitcoin, Megaphone, Store } from "lucide-react";
import UserAvatar from "./UserAvatar";

export default function Navbar() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate("/");
    };

    return (
        <nav
            data-testid="main-navbar"
            className="sticky top-0 z-40 w-full border-b-[3px] border-ink bg-vibrantyellow"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16 md:h-20">
                <Link
                    to="/"
                    data-testid="navbar-logo-link"
                    className="flex items-center gap-2 group"
                >
                    <div className="w-11 h-11 sm:w-12 sm:h-12 bg-white border-[3px] border-ink rounded-xl shadow-brutal overflow-hidden group-hover:rotate-[-6deg] transition-transform">
                        <img
                            src="/endfb-logo.png"
                            alt="Endfb"
                            className="w-full h-full object-cover"
                            data-testid="navbar-logo-img"
                        />
                    </div>
                    <span className="font-heading font-black text-2xl sm:text-3xl tracking-tighter text-ink">
                        End<span className="text-vibrantorange">fb</span>
                    </span>
                </Link>

                <div className="flex items-center gap-2 sm:gap-3">
                    {user && user !== false ? (
                        <>
                            <Link
                                to="/upload"
                                data-testid="navbar-upload-link"
                                className="brutal-btn-primary text-xs sm:text-sm py-2 px-3 sm:px-4"
                            >
                                <Upload className="w-4 h-4 mr-1.5" strokeWidth={2.5} />
                                Upload
                            </Link>
                            <Link
                                to="/buy-credits"
                                data-testid="navbar-deposit-link"
                                className="brutal-btn text-xs sm:text-sm py-2 px-3 bg-vibrantorange text-white"
                                title="Buy credits"
                            >
                                <Wallet className="w-4 h-4 sm:mr-1.5" strokeWidth={2.5} />
                                <span className="hidden sm:inline">Deposit</span>
                            </Link>
                            <Link
                                to="/cashout"
                                data-testid="navbar-cashout-link"
                                className="brutal-btn text-xs sm:text-sm py-2 px-3 bg-vibrantpink text-white"
                                title="Cash out to Bitcoin"
                            >
                                <Bitcoin className="w-4 h-4 sm:mr-1.5" strokeWidth={2.5} />
                                <span className="hidden sm:inline">Cashout</span>
                            </Link>
                            <Link
                                to="/kyc"
                                data-testid="navbar-kyc-link"
                                className="hidden sm:inline-flex brutal-btn-white text-xs sm:text-sm py-2 px-3"
                                title="KYC promotions & giveaways"
                            >
                                <Megaphone className="w-4 h-4 sm:mr-1.5" strokeWidth={2.5} />
                                <span className="hidden md:inline">KYC</span>
                            </Link>
                            <Link
                                to="/marketplace"
                                data-testid="navbar-marketplace-link"
                                className="hidden sm:inline-flex brutal-btn-white text-xs sm:text-sm py-2 px-3"
                                title="Buy and sell items for credits"
                            >
                                <Store className="w-4 h-4 sm:mr-1.5" strokeWidth={2.5} />
                                <span className="hidden md:inline">Market</span>
                            </Link>
                            <Link
                                to="/transfer"
                                data-testid="navbar-transfer-link"
                                className="hidden md:inline-flex brutal-btn-white text-xs sm:text-sm py-2 px-3"
                                title="Send credits"
                            >
                                Transfer
                            </Link>
                            <Link
                                to={`/u/${user.username}`}
                                data-testid="navbar-user-chip"
                                className="hidden sm:flex items-center gap-2 bg-white border-[3px] border-ink rounded-xl px-2 py-1.5 shadow-brutal hover:bg-cream"
                            >
                                <UserAvatar username={user.username} size={28} version={user.has_avatar ? "1" : "0"} className="!shadow-none !border-2" />
                                <span className="font-heading font-bold text-sm text-ink">{user.username}</span>
                            </Link>
                            <button
                                onClick={handleLogout}
                                data-testid="navbar-logout-button"
                                className="brutal-btn-white text-xs sm:text-sm py-2 px-3"
                                title="Log out"
                            >
                                <LogOut className="w-4 h-4" strokeWidth={2.5} />
                            </button>
                        </>
                    ) : (
                        <>
                            <Link
                                to="/login"
                                data-testid="navbar-login-link"
                                className="brutal-btn-white text-xs sm:text-sm py-2 px-3 sm:px-4"
                            >
                                <LogIn className="w-4 h-4 mr-1.5" strokeWidth={2.5} />
                                Login
                            </Link>
                            <Link
                                to="/register"
                                data-testid="navbar-register-link"
                                className="brutal-btn-primary text-xs sm:text-sm py-2 px-3 sm:px-4"
                            >
                                Join
                            </Link>
                        </>
                    )}
                </div>
            </div>
        </nav>
    );
}
